import api from "./api";


export const listAnamneseReviews = async (patientId) => {
  const response = await api.get("/contextual-ai/analyses", {
    params: {
      patient_id: patientId,
      context_type: "anamnese",
      page: 1,
      page_size: 100,
    },
  });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};


export const reviewAnamnese = async ({ patientId, responseId }) => {
  const response = await api.post("/ai-nlp/anamnese/analyze", {
    patient_id: patientId,
    response_id: responseId,
  });
  return response.data;
};


export const listEvolutionReviews = async (patientId) => {
  const response = await api.get("/contextual-ai/analyses", {
    params: {
      patient_id: patientId,
      context_type: "evolution",
      page: 1,
      page_size: 100,
    },
  });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};


export const reviewEvolution = async ({ patientId, evolutionId }) => {
  const response = await api.post("/contextual-ai/evolution/review", {
    patient_id: patientId,
    evolution_id: evolutionId,
  });
  return response.data;
};


export const listOdontogramReviews = async (patientId) => {
  const response = await api.get("/contextual-ai/analyses", {
    params: {
      patient_id: patientId,
      context_type: "odontogram",
      source_id: patientId,
      page: 1,
      page_size: 20,
    },
  });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};


export const reviewOdontogram = async (patientId) => {
  const response = await api.post("/contextual-ai/odontogram/review", {
    patient_id: patientId,
  });
  return response.data;
};


export const listDocumentReviews = async (patientId) => {
  const response = await api.get("/contextual-ai/analyses", {
    params: {
      patient_id: patientId,
      context_type: "document",
      page: 1,
      page_size: 100,
    },
  });
  return Array.isArray(response.data?.items) ? response.data.items : [];
};


export const reviewClinicalDocument = async ({ patientId, documentId }) => {
  const response = await api.post("/contextual-ai/document/review", {
    patient_id: patientId,
    document_id: documentId,
  });
  return response.data;
};


export const reviewPatientFinance = async (patientId) => {
  const response = await api.post("/contextual-ai/finance/review", {
    patient_id: patientId,
  });
  return response.data;
};


export const reviewPatientRecord = async (patientId) => {
  const response = await api.post("/contextual-ai/record-summary/review", {
    patient_id: patientId,
  });
  return response.data;
};


export const updateContextualAnalysisStatus = async (
  analysisId,
  status,
  editedContent = null
) => {
  const response = await api.patch(
    `/contextual-ai/analyses/${analysisId}/status`,
    {
      status,
      edited_content: editedContent,
    }
  );
  return response.data;
};


export const trackContextualAIEvent = async (event, data = {}) => {
  try {
    const { module = "anamnese", ...eventData } = data;
    await api.post("/contextual-ai/events", {
      event,
      module,
      ...eventData,
    });
  } catch {
    // Telemetria nunca deve interromper o fluxo clínico.
  }
};
